import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { jdrrFrameDeliveryStatus, getProjectId } from '../../lib/common';
import styles from './BannerFaq/Faq.module.scss';
import { useSessionStorage, useLocalStorage } from '../../hooks';
import { CreateTicket } from '../../api';
import useAlert from '../../hooks/useAlert';

function BannerFrameDeliveryStatus({ data }) {
  const [showTrackingDetails, setShowTrackingDetails] = useState(false);
  const [shouldShowDescription, setShouldShowDescription] = useState(false);
  const [ticketDescription, setTicketDescription] = useState('');
  const projectId = getProjectId();
  const [userDetails] = useSessionStorage('userDetails', '');
  const queryParams = new URLSearchParams(window.location.search);
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const navigate = useNavigate();
  const [setAlert] = useAlert();
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  const trackingDetailsObj = {
    OrderPlaced: {
      text: 'Order Placed',
      subText: 'We have received your order',
      val: data?.acctClearanceDate || '--',
      icon: styles.deliverybox__icon,
    },
    artwork: {
      text: 'Artwork Designed',
      subText: 'Artwork is ready for review. It is sent to client for approval',
      val: data?.artworkSentToClientDate || '--',
      icon: styles.monitor__icon,
    },
    clientApproved: {
      text: 'Client Approved',
      subText: 'No reply within 24 hrs will be considered as approval on design',
      val: data?.clientApprovedDate || '--',
      icon: styles.approvalstatus__icon,
    },
    frame: {
      text: 'Frame Printed & Picked Up',
      subText: 'Printed artwork is picked up by the courier vendor ',
      val: data?.recvdFromPrinterDate || '--',
      icon: styles.package__icon,
    },
    // transit: {
    //   text: 'In Transit',
    //   subText: 'Received at facility',
    //   val: data?.transit || '--',
    //   icon: styles.transit__icon,
    // },
    outDelivery: {
      text: 'Out for Delivery',
      subText: 'Received at facility',
      val: data?.dispatchArtworkDate || '--',
      icon: styles.outfordelivery__icon,
    },
    delivered: {
      text: 'Delivered',
      subText: 'Received by owner',
      val: data?.courierDeliveredDate || '--',
      icon: styles.delivered__icon,
    },
  };

  let flag = 0;
  Object.keys(trackingDetailsObj).forEach((key) => {
    if (flag === 1) {
      trackingDetailsObj[key].className = styles.disable;
    }
    if (trackingDetailsObj[key].val !== '--' && flag === 0) {
      trackingDetailsObj[key].className = styles.active;
    }
    if (trackingDetailsObj[key].val === '--' && flag === 0) {
      trackingDetailsObj[key].className = styles.deactive;
      flag = 1;
    }
  });
  const handleClick = () => {
    setShouldShowDescription((prev) => !prev);
  };
  const enableSubmitButton = ticketDescription.trim().length >= 3;

  const handleSubmit = async () => {
    const params = {
      vertical: 'LISTING',
      category: 'CS',
      ticket_creator: 'BUSINESS',
      nm:
        projectId === 'csportal'
          ? selectedBusiness?.compname || ''
          : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
      created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
      issue_type: 'JDRR Related',
      issue_sub_type: 'JDRR Not Received',
      issue_comment: ticketDescription,
      document: [],
      city:
        projectId === 'genio'
          ? selectedBusinessGenio?.city || ''
          : queryParams.get('city') || selectedBusiness?.data_city,
      oid: '',
      orderid: '',
      docid:
        projectId === 'genio'
          ? selectedBusinessGenio?.docId || ''
          : queryParams.get('pid') || selectedBusiness?.docid || '',
      src: projectId === 'genio' ? 'sales-genio' : 'business',
      src_typ:
        projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
      src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
      src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      projectId: projectId === 'csportal' ? 1 : '',
      parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
      compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
      source: '',
      classify: 1,
      bypass_autoclassify: 1,
      ...(projectId === 'genio' && {
        agent_mngr_id: profile?.reporteeCode,
        agent_id: profile?.empCode,
      }),
    };
    const res = await CreateTicket(params);
    if (res?.errorCode === 0) {
      setAlert({
        message: res?.result.msg || '',
        status: true,
      });
    } else {
      setAlert({
        message: res?.message || '',
        status: false,
      });
    }
    setTicketDescription('');
    setTimeout(() => {
      if (projectId === 'genio') {
        navigate('/genio/features');
      } else {
        navigate(-1);
      }
    }, 1000);
  };

  return (
    <>
      <div className="p-10">
        <ul className={`${styles.ListGroup}`}>
          {data &&
            Object.keys(data).length > 0 &&
            jdrrFrameDeliveryStatus &&
            Object.keys(jdrrFrameDeliveryStatus).map((each, idx) => (
              <li className={`${styles.ListItem}`} key={idx}>
                <label htmlFor={idx} className={`${styles.ListLabel} font13 fw400 color111`}>
                  {`${jdrrFrameDeliveryStatus?.[each]}:` || '--'}
                </label>
                <div className={`${styles.ListText} font13 fw500 color111`}>
                  :<span className={`capitalize font12 fw500 ml-4 `}>{data?.[each] || '--'}</span>
                </div>
              </li>
            ))}
        </ul>

        <div className="mt-4">
          <button
            id="ButtonNoBackground"
            type="button"
            onClick={() => {
              setShowTrackingDetails(true);
            }}
            className="anchor font13 fw600 color007 pl-4"
          >
            Click Here
          </button>
        </div>

        {showTrackingDetails && (
          <>
            <div className="font12 fw600 color1A1 mt-6 mb-6">JDRR Tracking Details</div>
            <ul className={`${styles.timeline__list}`}>
              {Object.keys(trackingDetailsObj).map((each, i) => (
                <li key={i} className={`${styles.timeline__item} ${trackingDetailsObj?.[each]?.className}`}>
                  <div className={`${styles.timeline__item__cirlce} csicon`} />
                  <div className={`${styles.timeline__itemcontent}`}>
                    <div className={`${styles.timeline__item__icon} ${trackingDetailsObj?.[each]?.icon} csicon`} />
                    <div className={`${styles.timeline__item__text}`}>
                      <div className={`${styles.timeline__item__heading}`}>
                        <div className={`${styles.heading} font14 fw400 color111`}>
                          {trackingDetailsObj?.[each]?.text || ''}
                        </div>
                        <div className={`${styles.date} font11 fw400 color777`}>
                          {trackingDetailsObj?.[each]?.val || '--'}
                        </div>
                      </div>
                      <div className="font11 fw400 color777">{trackingDetailsObj?.[each]?.subText || ''}</div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <div className={`${styles['certificate-not-received']}`}>
        <p className={`${styles.label}`}>Certificate not received?</p>
        <span className={`${styles['click-here']}`} onClick={handleClick}>
          Click here
        </span>
      </div>
      {shouldShowDescription && (
        <div className="mb-10 mt-10">
          <div style={{ fontWeight: 'bold' }} className="font15">
            Disclaimar:
          </div>
          <div style={{ color: 'gray' }} className="mt-10 mb-10 font15">
            The physical certificate will be delivered within 10 working days from the "Frame Printed & Picked Up" date
          </div>
          <textarea
            className={`${styles.Accordion__TextArea}`}
            placeholder="Write your query here..."
            onChange={(e) => {
              setTicketDescription(e.target.value);
            }}
          />
          <div className="mandatebtns fullwidthbtn" style={{ position: 'unset', background: 'none' }}>
            <button
              className={`${!enableSubmitButton ? 'mandatebtns_disabled' : 'mandatebtns_enable'} `}
              disabled={!enableSubmitButton}
              type="button"
              onClick={() => {
                handleSubmit();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default BannerFrameDeliveryStatus;

BannerFrameDeliveryStatus.propTypes = {
  data: PropTypes.object,
};
